import type { CSSProperties } from 'react'
import { cn } from '@/lib/utils'

export interface AdvancedAuthenticTaglineProps {
  className?: string
  lines?: [string, string]
}

const taglineFont = {
  fontFamily: '"EB Garamond", "Cormorant Garamond", Georgia, serif',
} satisfies CSSProperties

export function AdvancedAuthenticTagline({
  className,
  lines = ['the most advanced', 'the most authentic'],
}: AdvancedAuthenticTaglineProps) {
  return (
    <div
      className={cn(
        'inline-flex items-center gap-2 pl-3 text-slate-700',
        className,
      )}
      role="note"
      aria-label={`${lines[0]}. ${lines[1]}.`}
    >
      <span
        className="hidden h-9 w-px shrink-0 bg-gradient-to-b from-transparent via-amber-300/80 to-transparent sm:block"
        aria-hidden="true"
      />
      <div
        className="min-w-[8.5rem] text-center text-[13px] italic leading-[1.05] sm:text-[14px]"
        style={taglineFont}
      >
        <div>{lines[0]}</div>
        <div className="my-1 flex items-center justify-center gap-1.5" aria-hidden="true">
          <span className="h-px w-5 bg-gradient-to-r from-transparent to-amber-400/80" />
          <span className="h-1.5 w-1.5 rotate-45 bg-amber-500" />
          <span className="h-px w-5 bg-gradient-to-l from-transparent to-amber-400/80" />
        </div>
        <div>{lines[1]}</div>
      </div>
    </div>
  )
}

export default AdvancedAuthenticTagline
